import { Injectable } from '@angular/core';
import { LoginConfigService, LoginType, BaseViewConfigService } from 'gung-standard';
import { CultLoginComponent } from '../components/cult-login/cult-login.component';
import { GungLanguageConfigService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class CultLoginConfigService extends LoginConfigService {
  constructor(protected baseViewConfigService: BaseViewConfigService, protected languageConfigService: GungLanguageConfigService) {
    super(baseViewConfigService, languageConfigService);
  }

  getLoginType() {
    return LoginType.FashionLogin;
  }

  getLoginComponent(loginType?) {
    return CultLoginComponent;
  }
}
